import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { BodyText, SiteContainer } from '../styles/primitives';

const FooterWrapper = styled.footer`
  padding: ${({ theme }) => `${theme.spacing['2xl']} 0`};
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  background: rgba(255, 253, 249, 0.88);
`;

const FooterInner = styled(SiteContainer)`
  display: grid;
  gap: ${({ theme }) => theme.spacing.lg};
  align-items: center;

  ${({ theme }) => theme.media.md} {
    grid-template-columns: auto 1fr;
  }
`;

const FooterNav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.lg};
`;

const FooterLink = styled(NavLink)`
  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.textMuted};

  &:hover,
  &:focus-visible,
  &.active {
    color: ${({ theme }) => theme.colors.accentStrong};
  }
`;

const Copyright = styled(BodyText)`
  max-width: none;
  font-size: 0.92rem;
`;

const navigationItems = [
  { to: '/', label: 'Home' },
  { to: '/portfolio', label: 'Portfolio' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterInner>
        <FooterNav aria-label="Footer navigation">
          {navigationItems.map((item) => (
            <FooterLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => (isActive ? 'active' : undefined)}
            >
              {item.label}
            </FooterLink>
          ))}
        </FooterNav>
        <Copyright>
          &copy; {new Date().getFullYear()} Michelle Hunt. All photos and media on this site are owned by Michelle Hunt and are protected by copyright laws. Unauthorized use is prohibited.
        </Copyright>
      </FooterInner>
    </FooterWrapper>
  );
};

export default Footer;
